module.exports = __webpack_public_path__ + "img/Frame4.a38ebad7.png";